(function() {
  var filterContainer = document.querySelector('[data-collection-filters]');
  if (!filterContainer) return;

  var pills = filterContainer.querySelectorAll('.lm-collection__pill');
  var cards = document.querySelectorAll('.lm-collection__card');
  var countAnnounce = document.querySelector('[data-collection-count]');

  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      var tag = this.getAttribute('data-filter-tag');

      pills.forEach(function(p) {
        p.classList.remove('lm-collection__pill--active');
        p.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('lm-collection__pill--active');
      this.setAttribute('aria-pressed', 'true');

      var visibleCount = 0;
      cards.forEach(function(card) {
        if (tag === 'all') {
          card.removeAttribute('hidden');
          visibleCount++;
          return;
        }
        var cardTags = card.getAttribute('data-tags') || '';
        if (cardTags.indexOf(tag) !== -1) {
          card.removeAttribute('hidden');
          visibleCount++;
        } else {
          card.setAttribute('hidden', '');
        }
      });

      if (countAnnounce) {
        countAnnounce.textContent = 'Showing ' + visibleCount + ' product' + (visibleCount !== 1 ? 's' : '');
      }
    });
  });
})();
